



























































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import data from "@/services/data/cpi-ppi";
import categories from "@/services/categories";
import ComboBox from "@/components/ComboBox.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import moment from "moment";
import { isNil } from 'ramda';
import { it } from "vuejs-datepicker/dist/locale";
import {propertyTypes} from "@/services/properties";
import properties, {codes} from "@/services/properties/cpi-ppi";
import { format } from "date-fns";
import Header from "@/components/Header.vue";
import {PnetDatatable} from '@previnet/vue-datatable';
import jquery from 'jquery';
import Datatable from 'datatables.net';
import responsive from 'datatables.net-responsive';
import fixedHeader from 'datatables.net-fixedheader-dt';
import fixedColumns from 'datatables.net-fixedcolumns-dt';
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js'
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'
import 'datatables.net-fixedheader-bs4/js/fixedHeader.bootstrap4.min.js'
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'
import 'datatables.net-fixedcolumns-bs4/js/fixedColumns.bootstrap4.min.js'
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'
import config from "@/services/config";
import { mapGetters } from 'vuex';
import { Filter } from '@/services/filters';

const FILTER_KEY = "cpi-ppi-database";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user','filters','fromDashboard'],
  components: {
    PnetDatePicker,
    ComboBox,
    Header,
    MultiComboBox,
    PnetDatatable
  },
  computed: {
    ...mapGetters('filters', {
      filterById: 'byId',
    })
  },
  data: function() {
    return {
      config,
      fixedColumns,
      fixedHeader,
      jquery,
      loggedUser: this.$props.user,
      codCategoriaProdotto: categories.CPI_PPI,
      listaProdottiCensiti: [] as any[],
      listaProdottiCensitiForTable: [] as any[],
      listaProdottiCensitiPaginati: [] as any[],
      listaProdottiCensitiCurrent: [] as any[],
      filterOptions: {
        prodottoCompleto: [],
        prodotto: [],
        compagnia: [],
        mercato: [],
        canale: [],
        distributori: [],
        modDistribuzione: [],
        ramo: [],
        tipologiaGaranzie: [],
        prodottoInCommercio: [],
        tipologiaAssicurazione: [],
        premioTipologia: [],
        rischiAssicurati: [],
      },
      changedFilterFields: [],
      options: {
        fixedHeader: true,
        fixedColumns: {
          leftColumns: 0
        },
        responsive: true,
        paging: false,
        scrollX: true,
        scrollY: "500px",
        scrollCollapse: true,
        dom: 'lfrti',
        searching: false,
        info: false,
        autoWidth: true,
        order: [4, "asc"],
        language: {
          emptyTable: 'Nessun prodotto censito'
        }
      },
      page: 1,
      totPages: 1,
      needsPagination: false,
      itemsPerPage: 20,
      pageStart: 1,
      pageEnd: 20,
      columns: [
        {
          label: '',
          field: 'isSelected',
          render: function(data: any, type: any, row: any) {
            return "<input type='checkbox' id='isSelectedProd_"+row.id+"' name='isSelectedProd_"+row.id+"' data-toggle='tooltip' data-placement='right' title='Seleziona prodotto' class='selectProd' value='true' />";
          },
          className: 'text-center',
          tag: 'caratteristiche_generali',
        },
        {
          label: 'Visualizza',
          modalLabel: 'Visualizza',
          field: 'isToModify',
          render: function(data: any, type: any, row: any) {
            //const m = "<button id='isToModifyProd_"+row.id+"' name='isToModifyProd_"+row.id+"' data-toggle='tooltip' title='Modifica prodotto' class='btn btn-table p-1 pl-2 modifyProd'><i class='fa fa-pencil-square-o' aria-hidden='true'></i></button>";-->
            const s = "<button id='isToShowProd_"+row.id+"' name='isToShowProd_"+row.id+"' data-toggle='tooltip' data-placement='right' title='Visualizza prodotto' class='btn btn-table p-1 showProd'><i class='fa fa-search' aria-hidden='true'></i></button>";
            
            //return m + s;
            return s;
          },
          className: 'text-center',
        },
        {
          label: 'Prodotto completo',
          modalLabel: 'Prodotto completo',
          field: 'prodottoCompleto',
          render: function(data: any, type: any, row: any) {
            return data ? "Sì" : "No";
          },
          className: 'text-center',
          checkVisible: true,
        },
        {
          label: 'Codice prodotto',
          modalLabel: 'Codice prodotto',
          field: 'productCode',
          checkVisible: true,
        },
        {
          label: 'Prodotto',
          modalLabel: 'Prodotto',
          field: 'prodotto',
          width: '300px',
          orderable: true,
          modalShowHidden: true,
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Più versioni prodotto',
          modalLabel: 'Più versioni prodotto',
          field: 'piuTariffeProdotto',
          width: '300px',
        },
        {
          label: 'Codice prodotti collegati',
          modalLabel: 'Codice prodotti collegati',
          field: 'codiceProdottiCollegati',
          width: '300px',
          checkVisible: true,
          modalShowHidden: true,
        },
        {
          label: 'Compagnia',
          modalLabel: 'Compagnia',
          field: 'compagnia',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Canale',
          modalLabel: 'Canale',
          field: 'canale',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Distributori',
          modalLabel: 'Distributori',
          field: 'distributori',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Modalità di distribuzione',
          modalLabel: 'Modalità di distribuzione',
          field: 'modalitaDiDistribuzione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Mercato',
          modalLabel: 'Mercato',
          field: 'mercato',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Destinatari',
          modalLabel: 'Destinatari',
          field: 'destinatari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Target market',
          modalLabel: 'Target market',
          field: 'targetMarket',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Descrizione prodotto',
          modalLabel: 'Descrizione prodotto',
          field: 'descrizioneProdotto',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Linea di business',
          modalLabel: 'Linea di business',
          field: 'lineaBusiness',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ramo',
          modalLabel: 'Ramo',
          field: 'ramo',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia garanzie',
          modalLabel: 'Tipologia garanzie',
          field: 'tipologiaGaranzie',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Combinazione garanzie',
          modalLabel: 'Combinazione garanzie',
          field: 'combinazioneGaranzie',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Prodotto in commercio',
          modalLabel: 'Prodotto in commercio',
          field: 'prodottoInCommercio',
          width: '300px',
        },
        {
          label: 'Inizio commercializzazione',
          modalLabel: 'Inizio commercializzazione',
          field: 'inizioCommercializzazione',
          width: '300px',
          orderable: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Fine commercializzazione',
          modalLabel: 'Fine commercializzazione',
          field: 'fineCommercializzazione',
          width: '300px',
          orderable: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Edizione DIP aggiuntivo',
          modalLabel: 'Edizione DIP aggiuntivo',
          field: 'edizioneDIPAggiuntivo',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia di assicurazione',
          modalLabel: 'Tipologia di assicurazione',
          field: 'tipologiaDiAssicurazione',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Premio - \ntipologia',
          modalLabel: 'Premio - tipologia',
          field: 'premioTipologia',
          width: '300px',
          tag: 'requisiti_sottoscrizione',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'REQUISITI DI SOTTOSCRIZIONE',
          leftborder: true,
        },
        {
          label: 'Premio - \ndescrizione',
          modalLabel: 'Premio - descrizione',
          field: 'premioDescrizione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Frazionamento del premio',
          modalLabel: 'Frazionamento del premio',
          field: 'frazionamentoDelPremio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Durata contrattuale',
          modalLabel: 'Durata contrattuale',
          field: 'durataContrattuale',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Età massima alla sottoscrizione',
          modalLabel: 'Età massima alla sottoscrizione',
          field: 'etaMaxAllaSottoscrizione',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Età massima alla scadenza',
          modalLabel: 'Età massima alla scadenza',
          field: 'etaMaxAllaScadenza',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Documentazione richiesta',
          modalLabel: 'Documentazione richiesta',
          field: 'documentazioneRichiesta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        // Rischi
        {
          label: 'Rischi assicurati - \nRamo Vita',
          modalLabel: 'Rischi assicurati - Ramo Vita',
          field: 'rischiAssicuratiRamoVita',
          width: '300px',
          tag: 'garanzie',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'GARANZIE ASSICURATIVE',
          leftborder: true,
        },
        {
          label: 'Rischi assicurati - \nRamo Danni',
          modalLabel: 'Rischi assicurati - Ramo Danni',
          field: 'rischiAssicuratiRamoDanni',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },          
        },
        {
          label: 'Decesso (qualsiasi causa) - \ntipologia',
          modalLabel: 'Decesso (qualsiasi causa)',
          field: 'decessoQualsiasiCausa',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Decesso (qualsiasi causa) - \nprestazione',
          modalLabel: 'Decesso (qualsiasi causa) - prestazione',
          field: 'decessoQualsiasiCausaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Decesso da infortunio - \ntipologia',
          modalLabel: 'Decesso da infortunio',
          field: 'decessoDaInfortunio',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Decesso da infortunio - \nprestazione',
          modalLabel: 'Decesso da infortunio - prestazione',
          field: 'decessoDaInfortunioPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Decesso da malattia - \ntipologia',
          modalLabel: 'Decesso da malattia',
          field: 'decessoDaMalattia',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Decesso da malattia - \nprestazione',
          modalLabel: 'Decesso da malattia - prestazione',
          field: 'decessoDaMalattiaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità Permanente (qualsiasi causa) - \ntipologia',
          modalLabel: 'Invalidità Permanente (qualsiasi causa)',
          field: 'invaliditaPermanenteQualsiasiCausa',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità Permanente (qualsiasi causa) - \nprestazione',
          modalLabel: 'Invalidità Permanente (qualsiasi causa) - prestazione',
          field: 'invaliditaPermanenteQualsiasiCausaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità Permanente da infortunio - \ntipologia',
          modalLabel: 'Invalidità Permanente da infortunio',
          field: 'invaliditaPermanenteDaInfortunio',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità Permanente da infortunio - \nprestazione',
          modalLabel: 'Invalidità Permanente da infortunio - prestazione',
          field: 'invaliditaPermanenteDaInfortunioPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità Permanente da malattia - \ntipologia',
          modalLabel: 'Invalidità Permanente da malattia',
          field: 'invaliditaPermanenteDaMalattia',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità Permanente da malattia - \nprestazione',
          modalLabel: 'Invalidità Permanente da malattia - prestazione',
          field: 'invaliditaPermanenteDaMalattiaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità Temporanea (qualsiasi causa) - \ntipologia',
          modalLabel: 'Inabilità Temporanea (qualsiasi causa)',
          field: 'inabilitaTemporaneaQualsiasiCausa',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità Temporanea (qualsiasi causa) - \nprestazione',
          modalLabel: 'Inabilità Temporanea (qualsiasi causa) - prestazione',
          field: 'inabilitaTemporaneaQualsiasiCausaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità Temporanea da infortunio - \ntipologia',
          modalLabel: 'Inabilità Temporanea da infortunio',
          field: 'inabilitaTemporaneaDaInfortunio',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità Temporanea da infortunio - \nprestazione',
          modalLabel: 'Inabilità Temporanea da infortunio - prestazione',
          field: 'inabilitaTemporaneaDaInfortunioPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità Temporanea da malattia - \ntipologia',
          modalLabel: 'Inabilità Temporanea da malattia',
          field: 'inabilitaTemporaneaDaMalattia',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Inabilità Temporanea da malattia - \nprestazione',
          modalLabel: 'Inabilità Temporanea da malattia - prestazione',
          field: 'inabilitaTemporaneaDaMalattiaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Malattie gravi - \ntipologia',
          modalLabel: 'Malattie gravi',
          field: 'malattieGravi',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Malattie gravi - \nprestazione',
          modalLabel: 'Malattie gravi - prestazione',
          field: 'malattieGraviPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ricovero ospedaliero - \ntipologia',
          modalLabel: 'Ricovero ospedaliero',
          field: 'ricoveroOspedaliero',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ricovero ospedaliero - \nprestazione',
          modalLabel: 'Ricovero ospedaliero - prestazione',
          field: 'ricoveroOspedalieroPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ricovero per Grande Intervento Chirurgico - \ntipologia',
          modalLabel: 'Ricovero per Grande Intervento Chirurgico',
          field: 'ricoveroGrandeInterventoChirurgico',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ricovero per Grande Intervento Chirurgico - \nprestazione',
          modalLabel: 'Ricovero per Grande Intervento Chirurgico - prestazione',
          field: 'ricoveroGrandeInterventoChirurgicoPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Perdita d\'impiego - \ntipologia',
          modalLabel: 'Perdita d\'impiego',
          field: 'perditaImpiego',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Perdita d\'impiego - \nprestazione',
          modalLabel: 'Perdita d\'impiego - prestazione',
          field: 'perditaImpiegoPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altri rischi',
          modalLabel: 'Altri rischi',
          field: 'altriRischi',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        // trailer
        {
          label: 'Spese di emissione',
          modalLabel: 'Spese di emissione',
          field: 'speseEmissione',
          width: '300px',
          html: true,
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          tag: 'costi',
          sectionName: 'COSTI',
        },
        {
          label: 'Caricamento Ramo Vita',
          modalLabel: 'Caricamento Ramo Vita',
          field: 'costiRamoVita',
          width: '300px',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          }
        },
        {
          label: 'Caricamento Ramo Danni',
          modalLabel: 'Caricamento Ramo Danni',
          field: 'costiRamoDanni',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Specifiche caricamenti',
          modalLabel: 'Specifiche caricamenti',
          field: 'specificheCaricamenti',
          width: '300px',
          html: true,
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Interessi di frazionamento',
          modalLabel: 'Interessi di frazionamento',
          field: 'interessiDiFrazionamento',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },          
        },
        {
          label: 'Altri costi',
          modalLabel: 'Altri costi',
          field: 'altriCosti',
          width: '300px',
          html: true,
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Retrocessione alla distribuzione - \nRamo Vita',
          modalLabel: 'Ramo Vita',
          field: 'retrocessioneAllaDistribuzioneRamoVita',
          width: '300px',
          tag: 'retrocessione',
          sectionName: 'RETROCESSIONE ALLA DISTRIBUZIONE',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Retrocessione alla distribuzione - \nRamo Danni',
          modalLabel: 'Ramo Danni',
          field: 'retrocessioneAllaDistribuzioneRamoDanni',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Retrocessione alla distribuzione - \nSpecifiche',
          modalLabel: 'Specifiche',
          field: 'retrocessioneAllaDistribuzioneSpecifiche',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Note',
          modalLabel: 'Note',
          field: 'note',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
          sectionName: '',
        },
      ],
      tags: [
        { tag: 'caratteristiche_generali', label: 'Caratteristiche generali' },
        { tag: 'requisiti_sottoscrizione', label: 'Requisiti di sottoscrizione' },
        { tag: 'garanzie', label: 'Garanzie' },
        { tag: 'costi', label: 'Costi' },
        { tag: 'retrocessione', label: 'Retrocessione' },
      ],
      headers: {
        supergroups: [
          {
            key: 0,
            label: '',
            colspan: 4,
          },
          {
            key: 1,
            label: 'Caratteristiche generali',
            colspan: 20,
          },
          {
            key: 2,
            label: 'Requisiti di sottoscrizione',
            colspan: 7,
          },
          {
            key: 3,
            label: 'Garanzie assicurative',
            colspan: 29,
          },
          {
            key: 4,
            label: 'Costi',
            colspan: 3,
          },
          {
            key: 5,
            label: 'Retrocessione alla distribuzione',
            colspan: 3,
          },
          {
            key: 6,
            label: '',
            colspan: 1,
            leftborder: true,
          },
        ],
        groups: [
          {
            key: 0,
            label: '',
            colspan: 4,
          },
          {
            key: 1,
            label: '',
            colspan: 20,
            leftborder: true,
          },
          {
            key: 2,
            label: '',
            colspan: 7,
            leftborder: true,
          },
          {
            key: 3,
            label: 'Rischi assicurati',
            colspan: 2,
          },
          {
            key: 4,
            label: 'Decesso (qualsiasi causa)',
            colspan: 2,
          },
          {
            key: 5,
            label: 'Decesso da infortunio',
            colspan: 2,
          },
          {
            key: 6,
            label: 'Decesso da malattia',
            colspan: 2,
          },
          {
            key: 7,
            label: 'Invalidità permanente\n(qualsiasi causa)',
            colspan: 2,
          },
          {
            key: 8,
            label: 'Invalidità permanente\nda infortunio',
            colspan: 2,
          },
          {
            key: 9,
            label: 'Invalidità permanente\nda malattia',
            colspan: 2,
          },
          {
            key: 10,
            label: 'Inabilità temporanea\n(qualsiasi causa)',
            colspan: 2,
          },
          {
            key: 11,
            label: 'Inabilità temporanea\nda infortunio',
            colspan: 2,
          },
          {
            key: 12,
            label: 'Inabilità temporanea\nda malattia',
            colspan: 2,
          },
          {
            key: 13,
            label: 'Malattie gravi',
            colspan: 2,
          },
          {
            key: 14,
            label: 'Ricovero ospedaliero',
            colspan: 2,
          },
          {
            key: 15,
            label: 'Ricovero per\ngrande intervento\nchirurgico',
            colspan: 2,
          },
          {
            key: 16,
            label: 'Perdita d\'impiego',
            colspan: 2,
          },
          {
            key: 17,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 18,
            label: '',
            colspan: 3,
            leftborder: true,
          },
          {
            key: 19,
            label: '',
            colspan: 3,
            leftborder: true,
          },
          {
            key: 20,
            label: '',
            colspan: 1,
            leftborder: true,
          },
        ],
      },
      filtroRicerca: {
        prodottoCompleto: null,
        compagnia: [] as any,
        prodotto: [] as any,
        canale: [] as any,
        distributori: [] as any,
        modDistribuzione: [] as any,
        mercato: undefined,
        ramo: undefined,
        tipologiaGaranzie: [] as any,
        prodottoInCommercio: null,
        inizioCommercializzazioneDaDate: Date,
        inizioCommercializzazioneADate: Date,
        fineCommercializzazioneDaDate: Date,
        fineCommercializzazioneADate: Date,
        inizioCommercializzazioneDa: String,
        inizioCommercializzazioneA: String,
        fineCommercializzazioneDa: String,
        fineCommercializzazioneA: String,
        tipologiaAssicurazione: undefined,
        premioTipologia: [] as any,
        rischiAssicurati: [] as any,
      },
      operationToConfirm: "",
      msgError: "",
      msgSuccess: "",
      msgConfirmOperation: "",
      it,
      ...data,
      ...properties,
      propertyTypes,
      prodottiOptions: [] as any,
      distributoriOptions: [] as any,
      compagnieOptions: [] as any,
      ND: "n.d.",
      product: {} as any,
      productName: "",
      scrollTables: null as any,
      selectAll: false,
      updaterLoaded: false,
      updaterFile: undefined,
      updaterResult: undefined as any,
    };
  },
  methods: {
    storeFilter: function(filter: any) {
      var f: Filter = {
        id: FILTER_KEY,
        payload: filter !== undefined ? filter : this.filtroRicerca,
        changedFields: {},
        viewState: {},
      }
      this.$store.dispatch('filters/set', f);
    },
    getStoredFilter: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.payload;
    },
    resetFilterOptions: async function() {
      const vm = this as any;

      vm.filterOptions.prodottoCompleto = vm.yesNoOptions;
      vm.filterOptions.prodotto = vm.prodottiOptions;
      vm.filterOptions.compagnia = vm.compagnieOptions;
      vm.filterOptions.mercato = vm.mercatoOptions;
      vm.filterOptions.canale = vm.canaleOptions;
      vm.filterOptions.distributori = vm.distributoriOptions;
      vm.filterOptions.modDistribuzione = vm.modDistribuzioneOptions;
      vm.filterOptions.ramo = vm.ramoOptions;
      vm.filterOptions.tipologiaGaranzie = vm.tipologiaGaranzieOptions;
      vm.filterOptions.prodottoInCommercio = vm.yesNoOptions;
      vm.filterOptions.tipologiaAssicurazione = vm.tipologiaAssicurazioneOptions;
      vm.filterOptions.premioTipologia = vm.premioTipologiaOptions;
      vm.filterOptions.rischiAssicurati = vm.rischiAssicuratiOptions;
    },
    emptyNoDynamicFiltroRicerca: async function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
      vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.fineCommercializzazioneADate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
      vm.filtroRicerca.inizioCommercializzazioneA = undefined;
      vm.filtroRicerca.fineCommercializzazioneDa = undefined;
      vm.filtroRicerca.fineCommercializzazioneA = undefined;
    },
    emptyFilterOptions: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('prodottoCompleto') ||
          vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
        vm.filterOptions.prodottoCompleto = []; 
      }
      if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filterOptions.prodotto = [];
      }
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filterOptions.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filterOptions.mercato = [];
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filterOptions.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filterOptions.distributori = [];
      }
      if (!vm.changedFilterFields.includes('modDistribuzione') ||
          vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
        vm.filterOptions.modDistribuzione = [];
      }
      if (!vm.changedFilterFields.includes('ramo') ||
          vm.changedFilterFields.indexOf('ramo') > indexOfChangedField) {
        vm.filterOptions.ramo = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzie') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzie') > indexOfChangedField) {
        vm.filterOptions.tipologiaGaranzie = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filterOptions.prodottoInCommercio = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaAssicurazione') ||
          vm.changedFilterFields.indexOf('tipologiaAssicurazione') > indexOfChangedField) {
        vm.filterOptions.tipologiaAssicurazione = [];
      }
      if (!vm.changedFilterFields.includes('premioTipologia') ||
          vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
        vm.filterOptions.premioTipologia = [];
      }
      if (!vm.changedFilterFields.includes('rischiAssicurati') ||
          vm.changedFilterFields.indexOf('rischiAssicurati') > indexOfChangedField) {
        vm.filterOptions.rischiAssicurati = [];
      }
    },
    emptyFiltroRicerca: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('prodottoCompleto') ||
          vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
        vm.filtroRicerca.prodottoCompleto = null;
      }
      if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filtroRicerca.prodotto = [];
      }
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filtroRicerca.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filtroRicerca.mercato = undefined;
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filtroRicerca.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filtroRicerca.distributori = [];
      }
      if (!vm.changedFilterFields.includes('modDistribuzione') ||
          vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
        vm.filtroRicerca.modDistribuzione = [];
      }
      if (!vm.changedFilterFields.includes('ramo') ||
          vm.changedFilterFields.indexOf('ramo') > indexOfChangedField) {
        vm.filtroRicerca.ramo = undefined;
      }
      if (!vm.changedFilterFields.includes('tipologiaGaranzie') ||
          vm.changedFilterFields.indexOf('tipologiaGaranzie') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaGaranzie = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filtroRicerca.prodottoInCommercio = null;
      }
      if (!vm.changedFilterFields.includes('tipologiaAssicurazione') ||
          vm.changedFilterFields.indexOf('tipologiaAssicurazione') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaAssicurazione = undefined;
      }
      if (!vm.changedFilterFields.includes('premioTipologia') ||
          vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
        vm.filtroRicerca.premioTipologia = [];
      }
      if (!vm.changedFilterFields.includes('rischiAssicurati') ||
          vm.changedFilterFields.indexOf('rischiAssicurati') > indexOfChangedField) {
        vm.filtroRicerca.rischiAssicurati = [];
      }
    },
    emptyChangedFilterFields() {
      const vm = this as any;

      vm.changedFilterFields = [];
    },
    resetFilterOptionsAndEmptyFiltroRicerca() {
      const vm = this as any;

      vm.resetFilterOptions();
      vm.emptyNoDynamicFiltroRicerca();
      vm.emptyFiltroRicerca(-1);
      vm.emptyChangedFilterFields();
      vm.storeFilter();
    },
    repopulateFiltersOptionsChangedCompagnia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('compagnia');
    },
    repopulateFiltersOptionsChangedProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('prodotto');
    },
    repopulateFiltersOptionsChangedDistributori: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('distributori');
    },
    repopulateFiltersOptionsChangedCanale: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('canale');
    },
    repopulateFiltersOptionsChangedModDistribuzione: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('modDistribuzione');
    },
    repopulateFiltersOptionsChangedTipologiaGaranzie: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaGaranzie');
    },    
    repopulateFiltersOptionsChangedGaranzie: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('garanzie');
    },
    repopulateFiltersOptionsChangedTipologiaProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaProdotto');
    },
    repopulateFiltersOptionsChangedPremioTipologia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('premioTipologia');
    },
    repopulateFiltersOptionsChangedRischiAssicurati: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('rischiAssicurati');
    },
    repopulateFiltersOptions: async function(changedFieldName: string) {
      const vm = this as any;

      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean

      // mantenere l'ordine!
      if (!vm.changedFilterFields.includes(changedFieldName)) {
        vm.changedFilterFields.push(changedFieldName);
      }
      const indexOfChangedField = vm.changedFilterFields.indexOf(changedFieldName)
      vm.emptyFilterOptions(indexOfChangedField);
      vm.emptyFiltroRicerca(indexOfChangedField);
      if (indexOfChangedField + 1 < vm.changedFilterFields.length) {
        vm.changedFilterFields.splice(indexOfChangedField+1, (vm.changedFilterFields.length-indexOfChangedField+1));
      }
      if (vm.filtroRicerca[changedFieldName] === undefined ||
          vm.filtroRicerca[changedFieldName] === null ||
          vm.filtroRicerca[changedFieldName].length == 0) {
        vm.changedFilterFields.pop();
      }
      //console.log(JSON.stringify(vm.filtroRicerca[changedFieldName]));
      //console.log(indexOfChangedField  + " " + changedFieldName + " vm.changedFilterFields " + JSON.stringify(vm.changedFilterFields));

      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {

              // Prodotto completo
              if (!vm.changedFilterFields.includes('prodottoCompleto') ||
                  vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
                let filterProdottoCompletoOption = { code : vm.listaProdottiCensiti[i].completed , value : (vm.listaProdottiCensiti[i].completed ? "Sì" : "No" ) };
                vm.pushOptionValue(filterProdottoCompletoOption,vm.filterOptions.prodottoCompleto);
              }

              // Prodotto
              if (!vm.changedFilterFields.includes('prodotto') ||
                  vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
                let filterProdottoOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodottoProperty);
                vm.pushOptionValueProdotto(filterProdottoOption,vm.filterOptions.prodotto);
              }

              // Compagnia
              if (!vm.changedFilterFields.includes('compagnia') ||
                  vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
                let filterCompagniaOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.compagniaProperty);
                vm.pushOptionValues(filterCompagniaOption,vm.filterOptions.compagnia);
              }

              // Mercato
              if (!vm.changedFilterFields.includes('mercato') ||
                  vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
                let filterMercatoOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.mercatoProperty);
                vm.pushOptionValues(filterMercatoOption,vm.filterOptions.mercato);
              }

              // Canale
              if (!vm.changedFilterFields.includes('canale') ||
                  vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
                let filterCanaleOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.canaleProperty);
                vm.pushOptionValues(filterCanaleOption,vm.filterOptions.canale);
              }

              // Distributori
              if (!vm.changedFilterFields.includes('distributori') ||
                  vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
                let filterDistributoriOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.distributoriProperty);
                vm.pushOptionStringList(filterDistributoriOption,vm.filterOptions.distributori,'distributori');
              }

              // Modalità di distribuzione
              if (!vm.changedFilterFields.includes('modDistribuzione') ||
                  vm.changedFilterFields.indexOf('modDistribuzione') > indexOfChangedField) {
                let filterModDistribuzioneOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.modDistribuzioneProperty);
                vm.pushOptionValues(filterModDistribuzioneOption,vm.filterOptions.modDistribuzione);
              }

              // Ramo
              if (!vm.changedFilterFields.includes('ramo') ||
                  vm.changedFilterFields.indexOf('ramo') > indexOfChangedField) {
                let filterRamoOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoProperty);
                vm.pushOptionValues(filterRamoOption,vm.filterOptions.ramo);
              }

              // Tipologia Garanzie
              if (!vm.changedFilterFields.includes('tipologiaGaranzie') ||
                  vm.changedFilterFields.indexOf('tipologiaGaranzie') > indexOfChangedField) {
                let filterTipologiaGaranzieOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaGaranzieProperty);
                vm.pushOptionValues(filterTipologiaGaranzieOption,vm.filterOptions.tipologiaGaranzie);
              }

              // Prodotto in commercio
              if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
                  vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
                const prodCommercio = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodCommercioProperty);
                let filterProdottoInCommercioOption = { code : (prodCommercio.code == "16.1" ? true : false) , value : prodCommercio.value };
                vm.pushOptionValue(filterProdottoInCommercioOption,vm.filterOptions.prodottoInCommercio);
              }

              // Tipologia di assicurazione
              if (!vm.changedFilterFields.includes('tipologiaAssicurazione') ||
                  vm.changedFilterFields.indexOf('tipologiaAssicurazione') > indexOfChangedField) {
                let filterTipologiaAssicurazioneOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaAssicurazioneProperty);
                vm.pushOptionValue(filterTipologiaAssicurazioneOption,vm.filterOptions.tipologiaAssicurazione);
              }

              // Tipologia premio
              if (!vm.changedFilterFields.includes('premioTipologia') ||
                  vm.changedFilterFields.indexOf('premioTipologia') > indexOfChangedField) {
                let filterPremioTipologiaOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.premioTipologiaProperty);
                vm.pushOptionValues(filterPremioTipologiaOption,vm.filterOptions.premioTipologia);
              }

              // Rischi assicurati (fusione di vita e danni)
              if (!vm.changedFilterFields.includes('rischiAssicurati') ||
                  vm.changedFilterFields.indexOf('rischiAssicurati') > indexOfChangedField) {
                const filterRischiAssicuratiRamoVitaOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrDistrVitaProperty);
                const filterRischiAssicuratiRamoDanniOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrDistrDanniProperty);
                const filterRischiAssicuratiRamoVitaOptionInDomain = vm.getValuesInDomain(filterRischiAssicuratiRamoVitaOption.values,data.rischiAssicuratiOptions);
                const filterRischiAssicuratiRamoDanniOptionInDomain = vm.getValuesInDomain(filterRischiAssicuratiRamoDanniOption.values,data.rischiAssicuratiOptions);
                vm.pushOptionValuesWithMerge(filterRischiAssicuratiRamoVitaOptionInDomain,vm.filterOptions.rischiAssicurati);
                vm.pushOptionValuesWithMerge(filterRischiAssicuratiRamoDanniOptionInDomain,vm.filterOptions.rischiAssicurati);
              }
            }
          }

          // sort rischiAssicurati
          vm.filterOptions.rischiAssicurati.sort( vm.optionCodeCompare );

          return null;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico 1");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getProperty: function(propertyList: any, code: string) {
      let res = undefined;
      const regexCode = /^([0-9]+)([a-z]*)/i;
      let codePrefix = undefined;
      let codeSuffix = undefined;
      const codeMatch = regexCode.exec(code);
      let re: any = undefined;
      if (codeMatch) {
        codePrefix = codeMatch[1] || "";
        codeSuffix = codeMatch[2] || "";
        re = new RegExp(`^${codePrefix}\\.[0-9]${codeSuffix}`);
      }
      const p = propertyList.find((p: any) => {
        let match = false;
        const equals = p.code === code;
        if (!equals && re != undefined) {
          match = re.test(p.code);
        }
        return equals || match;
      });
      return p || {};
    },
    retrieveProductsList: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean
      vm.listaProdottiCensitiForTable = []; //clean

      vm.setDatePropertiesValue();

      const noDashed = true;

      if (vm.$props.filters == undefined) {
        vm.storeFilter();
      }
      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          vm.listaProdottiCensiti.sort(function(a: any, b: any) {
            const nameA = a.properties[0].value.toUpperCase(); // ignora maiuscole e minuscole
            const nameB = b.properties[0].value.toUpperCase(); // ignora maiuscole e minuscole
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            const codeA = a.productCode; // ignora maiuscole e minuscole
            const codeB = b.productCode; // ignora maiuscole e minuscole
            if (codeA < codeB) {
              return -1;
            }
            if (codeA > codeB) {
              return 1;
            }

            return 0;
          });

          const prodotti = vm.listaProdottiCensiti.length;
          if (prodotti > vm.itemsPerPage) {
            const p = prodotti / vm.itemsPerPage;
            vm.totPages = Math.floor(p);
            if (p > vm.totPages) {
              vm.totPages += 1;
            }
          } else {
            vm.totPages = 1;
          }
          vm.needsPagination = vm.totPages > 1;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {
              let obj = {} as any;
              obj.id = i;
              obj.isSelected = false;
              obj.isToModify = vm.isAdmin();
              obj.prodottoCompleto = vm.listaProdottiCensiti[i].completed;
              obj.productId = vm.listaProdottiCensiti[i].productId;
              obj.productCode = vm.listaProdottiCensiti[i].productCode;
              obj.prodotto = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodottoProperty));
              obj.piuTariffeProdotto = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.piuTariffeProperty).value;
              obj.codiceProdottiCollegati = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.codProdCollegatoProperty).value;
              obj.compagnia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.compagniaProperty));
              obj.canale = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.canaleProperty));
              obj.distributori = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.distributoriProperty));
              obj.modalitaDiDistribuzione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.modDistribuzioneProperty));
              obj.mercato = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.mercatoProperty));
              obj.destinatari = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.destinatariProperty));
              obj.targetMarket = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.targetMarketProperty));
              obj.descrizioneProdotto = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.descProdottoProperty));
              obj.lineaBusiness = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.lineaBusinessProperty));
              obj.ramo = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoProperty));
              obj.tipologiaGaranzie = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaGaranzieProperty));
              obj.combinazioneGaranzie = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.combinazioneGaranzieProperty));
              obj.prodottoInCommercio = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodCommercioProperty).value;
              obj.inizioCommercializzazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inizioCommProperty));
              obj.fineCommercializzazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.fineCommProperty));
              obj.edizioneDIPAggiuntivo = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.edizioneDIPAggProperty));
              obj.tipologiaDiAssicurazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaAssicurazioneProperty));
              obj.premioTipologia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.premioTipologiaProperty));
              obj.premioDescrizione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.premioDescProperty));
              obj.frazionamentoDelPremio = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.frazPremioProperty));
              obj.durataContrattuale = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.durataProperty));
              obj.etaMaxAllaSottoscrizione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.etaMaxAllaSottoscrizioneProperty), false);
              obj.etaMaxAllaScadenza = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.etaMaxAllaScadenzaProperty), false);
              obj.documentazioneRichiesta = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.docRichiestaProperty));
              // Rischi
              obj.rischiAssicuratiRamoVita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.rischiAssicuratiRamoVitaProperty));
              obj.rischiAssicuratiRamoDanni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.rischiAssicuratiRamoDanniProperty));
              obj.decessoQualsiasiCausa = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.decessoQualsiasiCausaProperty));
              obj.decessoQualsiasiCausaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.decessoQualsiasiCausaPrestazioneProperty));
              obj.decessoDaInfortunio = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.decessoDaInfortunioProperty));
              obj.decessoDaInfortunioPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.decessoDaInfortunioPrestazioneProperty));
              obj.decessoDaMalattia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.decessoDaMalattiaProperty));
              obj.decessoDaMalattiaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.decessoDaMalattiaPrestazioneProperty));
              obj.invaliditaPermanenteQualsiasiCausa = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaPermanenteQualsiasiCausaProperty));
              obj.invaliditaPermanenteQualsiasiCausaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaPermanenteQualsiasiCausaPrestazioneProperty));
              obj.invaliditaPermanenteDaInfortunio = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaPermanenteDaInfortunioProperty));
              obj.invaliditaPermanenteDaInfortunioPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaPermanenteDaInfortunioPrestazioneProperty));
              obj.invaliditaPermanenteDaMalattia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaPermanenteDaMalattiaProperty));
              obj.invaliditaPermanenteDaMalattiaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaPermanenteDaMalattiaPrestazioneProperty));
              obj.inabilitaTemporaneaQualsiasiCausa = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inabilitaTemporaneaQualsiasiCausaProperty));
              obj.inabilitaTemporaneaQualsiasiCausaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty));
              obj.inabilitaTemporaneaDaInfortunio = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inabilitaTemporaneaDaInfortunioProperty));
              obj.inabilitaTemporaneaDaInfortunioPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inabilitaTemporaneaDaInfortunioPrestazioneProperty));
              obj.inabilitaTemporaneaDaMalattia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inabilitaTemporaneaDaMalattiaProperty));
              obj.inabilitaTemporaneaDaMalattiaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inabilitaTemporaneaDaMalattiaPrestazioneProperty));
              obj.malattieGravi = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.malattieGraviProperty));
              obj.malattieGraviPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.malattieGraviPrestazioneProperty));
              obj.ricoveroOspedaliero = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ricoveroOspedalieroProperty));
              obj.ricoveroOspedalieroPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ricoveroOspedalieroPrestazioneProperty));
              obj.ricoveroGrandeInterventoChirurgico = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ricoveroGrandeInterventoChirurgicoProperty));
              obj.ricoveroGrandeInterventoChirurgicoPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ricoveroGrandeInterventoChirurgicoPrestazioneProperty));
              obj.perditaImpiego = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.perditaImpiegoProperty));
              obj.perditaImpiegoPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.perditaImpiegoPrestazioneProperty));
              obj.altriRischi = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.altriRischiProperty));
              // trailer
              obj.speseEmissione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.speseEmissioneProperty));
              obj.costiRamoVita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.costiRamoVitaProperty), noDashed);
              obj.costiRamoDanni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.costiRamoDanniProperty), noDashed);
              obj.specificheCaricamenti = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.specificheCaricamentiProperty));
              obj.interessiDiFrazionamento = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.interessiFrazProperty));
              obj.altriCosti = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.altriCostiProperty));
              obj.retrocessioneAllaDistribuzioneRamoVita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrDistrVitaProperty));
              obj.retrocessioneAllaDistribuzioneRamoDanni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrDistrDanniProperty));
              obj.retrocessioneAllaDistribuzioneSpecifiche = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrDistrSpecificheProperty));
              obj.note = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.noteProperty));

              vm.listaProdottiCensitiForTable.push(obj);
            }
          }

          vm.listaProdottiCensitiPaginati = [];
          for (let i = 0; i < vm.totPages; i++) {
            const s = vm.itemsPerPage * i;
            const e = vm.itemsPerPage * (i + 1);
            const sliced = vm.listaProdottiCensitiForTable.slice(s, e);
            vm.listaProdottiCensitiPaginati.push(sliced);
          }

          vm.listaProdottiCensitiCurrent = vm.listaProdottiCensitiPaginati[0];

          return null;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico 2");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getPropertyValues: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      const serviceCallReturnValue = await requestService.getPropertyValues(vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.prodottiOptions = result.prodotti;
          vm.distributoriOptions = result.distributori;
          vm.compagnieOptions = result.compagnie;
        })
        .catch(function(e) {
          vm.openModalError("Errore generico 3");
        });

      vm.$loadingService.stopLoading("loading");
    },    
    inizializzaFiltroRicerca: function() {
      const vm = this as any;

      let filter = this.$props.filters;
      if (filter == undefined) {
        filter = vm.getStoredFilter();
      }

      if (filter == undefined) {
        vm.filtroRicerca.prodottoCompleto = null;
        vm.filtroRicerca.compagnia = [] as any;
        vm.filtroRicerca.prodotto = [] as any;
        vm.filtroRicerca.canale = [] as any;
        vm.filtroRicerca.distributori = [] as any;
        vm.filtroRicerca.modDistribuzione = [] as any;
        vm.filtroRicerca.mercato = undefined;
        vm.filtroRicerca.ramo = undefined;
        vm.filtroRicerca.tipologiaGaranzie = [] as any;
        vm.filtroRicerca.prodottoInCommercio = null;
        vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
        vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.fineCommercializzazioneADate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
        vm.filtroRicerca.inizioCommercializzazioneA = undefined;
        vm.filtroRicerca.fineCommercializzazioneDa = undefined;
        vm.filtroRicerca.fineCommercializzazioneA = undefined;
        vm.filtroRicerca.tipologiaAssicurazione = undefined;
        vm.filtroRicerca.premioTipologia = [] as any;
        vm.filtroRicerca.rischiAssicurati = [] as any;
      } else {
        vm.filtroRicerca = filter;
      }
    },
    pushOptionValue(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value)) {
        filter.push({ code : filterOptionToInsert.code , description : filterOptionToInsert.value });
      }
    },
    pushOptionValueProdotto(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value)) {
        filter.push({ code : filterOptionToInsert.code + "_" + filterOptionToInsert.value , description : filterOptionToInsert.value });
      }
    },
    pushOptionValues(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      filterOptionToInsert.values.forEach((v: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.code == v.code && o.description == v.description) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent) {
          filter.push({ code : v.code , description : v.description })
        }
      });
    },
    pushOptionValuesWithMerge(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      filterOptionToInsert.forEach((v: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          const vOptionCode = "." + v.code.split(".")[1];
          const oOptionCode = "." + o.code.split(".")[1];
          if (oOptionCode == vOptionCode && o.description == v.description) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent) {
          const vOptionCode = "." + v.code.split(".")[1];
          filter.push({ code : vOptionCode , description : v.description })
        }
      });
    },
    optionCodeCompare(a: any, b: any) {
      const aCode = parseInt(a.code.substring(1)); //elimina il '.' iniziale
      const bCode = parseInt(b.code.substring(1)); //elimina il '.' iniziale

      if ( aCode < bCode ){
        return -1;
      }
      if ( aCode > bCode ){
        return 1;
      }
      return 0;
    },
    getValuesInDomain(values: any, domain: any) {
      let retValues = [] as any;

      values.forEach((v: any) => {
        domain.forEach((item: any) => {
          const optionCodeTrailer = v.code.split('.')[1];
          const itemCodeTrailer = item.code.split('.')[1];
          if (optionCodeTrailer == itemCodeTrailer) {
            retValues.push({code:v.code,description:v.description});
          }
        });
      });

      return retValues;
    },
    pushOptionStringList(filterOptionToInsert: any, filter: any, fieldName: string) {
      const vm = this as any;

      filterOptionToInsert.stringList.forEach((s: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.description == s.value) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent && !vm.isEmptyOrSpaces(s.value)) {
          let index = filter.length;
          filter.push({ code : categories.CPI_PPI + "-" + fieldName + "-" + index, description : s.value });
        }
      });
    },
    homeProdotti: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      if (vm.fromDashboard) {
        vm.dashboardCPIPPI();
      } else {
        vm.$router.go(-1);
      }
    },
    dashboardCPIPPI: function() {
      const vm = this as any;
      const isAdvanced = vm.isAdvanced() || vm.isAdmin();
      if (!isAdvanced || vm.noDashboard()) { return; }
      vm.$router.push({ name: 'dashboard-cpi-ppi', params: {user: vm.loggedUser, fromDatabase: true}});
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    setIsSelected: function(index: number) {
      const vm = this as any;
      vm.listaProdottiCensitiForTable[index].isSelected = !vm.listaProdottiCensitiForTable[index].isSelected;
      if (!vm.listaProdottiCensitiForTable[index].isSelected) {
        vm.selectAll = false;
        jquery('#isSelectedAll').prop('checked', false);
      }
    },
    setIsSelectedAll: function() {
      const vm = this as any;
      vm.selectAll = !vm.selectAll;
      vm.listaProdottiCensitiForTable.forEach(function (c: any) {
        c.isSelected = vm.selectAll;
      });
      jquery('.selectProd').prop('checked', vm.selectAll);
    },
    isCompleted: function(index: number) {
      const vm = this as any;
      return vm.listaProdottiCensitiForTable[index].prodottoCompleto ? "Sì" : "No";
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    setDatePropertiesValue: function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneDaDate);
      vm.filtroRicerca.inizioCommercializzazioneA = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneADate);
      vm.filtroRicerca.fineCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneDaDate);
      vm.filtroRicerca.fineCommercializzazioneA = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneADate);
    },
    exportCSV: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected &&
            vm.listaProdottiCensitiForTable[i].prodottoCompleto) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      if (productIdsFilter.length <= 0) {
        vm.openModalError("Non verrà estratto alcun prodotto in quanto nessun prodotto selezionato è completo");
      } else {
        let contentType = '';
        let csvName = '';
        const filtro = vm.filtroRicerca;
        filtro.ids = productIdsFilter;
        filtro.categoriaProdotto = vm.codCategoriaProdotto;
        const serviceCallReturnValue = await requestService
          .extractCSV(filtro)
          .then((response: any) => {
            const headerContentType = response.headers.get("content-type");
            contentType = headerContentType !== null ? headerContentType : 'application/csv';
            return response.blob();
          })
          .then((blob: any) => {
            csvName = 'product-export.csv';          
            vm.downloadDocFromBlob(blob, csvName, contentType);
          })
          .catch(() => {
            vm.openModalError("Errore generico 4");
          })
      }

      vm.stopLoading();
    },
    exportExcel: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected &&
            vm.listaProdottiCensitiForTable[i].prodottoCompleto) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      if (productIdsFilter.length <= 0) {
        vm.openModalError("Non verrà estratto alcun prodotto in quanto nessun prodotto selezionato è completo");
      } else {
        let contentType = '';
        let xlsName = '';
        const filtro = vm.filtroRicerca;
        filtro.ids = productIdsFilter;
        filtro.categoriaProdotto = vm.codCategoriaProdotto;
        const serviceCallReturnValue = await requestService
          .extractXlsx(filtro)
          .then((response: any) => {
            const headerContentType = response.headers.get("content-type");
            contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
            return response.blob();
          })
          .then((blob: any) => {
            xlsName = 'product-export.xlsx';          
            vm.downloadDocFromBlob(blob, xlsName, contentType);
          })
          .catch((e) => {
            console.log(e);
            vm.openModalError("Errore generico 5");
          })
      }

      vm.stopLoading();
    },
    exportPptx: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected &&
            vm.listaProdottiCensitiForTable[i].prodottoCompleto) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      if (productIdsFilter.length <= 0) {
        vm.openModalError("Non verrà estratto alcun prodotto in quanto nessun prodotto selezionato è completo");
      } else {
        let contentType = '';
        let filename = '';
        const filtro = vm.filtroRicerca;
        filtro.ids = productIdsFilter;
        filtro.categoriaProdotto = vm.codCategoriaProdotto;
        const serviceCallReturnValue = await requestService
          .extractPptx(filtro)
          .then((response: any) => {
            const headerContentType = response.headers.get("content-type");
            contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
            return response.blob();
          })
          .then((blob: any) => {
            filename = 'product-export.pptx';
            vm.downloadDocFromBlob(blob, filename, contentType);
          })
          .catch(() => {
            vm.openModalError("Errore generico");
          })
      }

      vm.stopLoading();
    },
    updaterExport() {
      const vm = this as any;
      vm.startLoading();

      let contentType = '';
      let filename = `${categories.CPI_PPI}.xlsx`;
      requestService
        .updaterExport(categories.CPI_PPI)
        .then((response: any) => {
          const headerContentType = response.headers.get("content-type");
          const headerContentDisposition = response.headers.get("content-disposition");
          contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
          if (headerContentDisposition) {
            const split = headerContentDisposition.split("=");
            if (split.length > 1) {
              filename = split[split.length - 1];
            }
          }

          return response.blob();
        })
        .then((blob: any) => {
          vm.downloadDocFromBlob(blob, filename, contentType);
          vm.stopLoading();
        })
        .catch(() => {
          vm.openModalError("Errore generico");
        });
    },
    updaterUpload() {
      const vm = this as any;
      vm.startLoading();
      requestService.updaterUpload(categories.CPI_PPI, vm.updaterFile)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          if (result !== undefined) {
            vm.updaterLoaded = true;
            vm.updaterResult = result;
          } else {
            vm.closeModalUpdaterUpload();
            vm.openModalError("Non è stato possibile caricare il file.");
          }
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile caricare il file.");
        });
    },
    confirmUpdaterUpload() {
      const vm = this as any;
      vm.updaterLoaded = false;
      vm.updaterResult = undefined;
      vm.closeModalUpdaterUpload();
      vm.retrieveProductsList();
    },
    openModalUpdaterUpload: function() {
      const vm = this as any;
      vm.massiveFile = undefined;
      vm.massiveLoaded = false;
      vm.massiveResult = null;
      vm.$bvModal.show("modal-updater-upload");
    },
    closeModalUpdaterUpload() {
      const vm = this as any;
      vm.$bvModal.hide("modal-updater-upload");
    },
    selectedFile: function(fileList: any[]) {
      if (!fileList.length) return;
      this.updaterFile = fileList[0];
    },
    downloadDocFromBlob(blob: any, name: string, contentType: string) {
      const newBlob = new Blob([blob], { type: contentType });

      // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, name);
      } else {
        // For other browsers: create a link pointing to the ObjectURL containing the blob.
        const objUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = objUrl;
        link.target = '_blank';
        link.download = name;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL.
        setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
      }
    },
    addProduct: async function() {
      const vm = this as any;

      vm.$router.push({ name: 'cpi-ppi', params: {user: vm.loggedUser}});
    },
    modifyProduct: async function(row: any) {
      const vm = this as any;

      const productIdsFilter = [] as any;
      if (row !== undefined) {
        productIdsFilter.push(vm.listaProdottiCensitiForTable[row].productId);
      } else {
        let i;
        for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
          if (vm.listaProdottiCensitiForTable[i].isSelected) {
            productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
          }
        }
      }

      let productIdToModify = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da modificare.");
      } else {
        productIdToModify = productIdsFilter[0];
        vm.$router.push({ name: 'cpi-ppi', params: {user: vm.loggedUser, productId: productIdToModify}});
      }
    },
    showProduct: async function(row: any) {
      const vm = this as any;

      let p = null as any;
      let op = null as any;
      const productFilter = [] as any;
      if (row !== undefined) {
        p = vm.listaProdottiCensitiForTable[row];
        op = vm.listaProdottiCensiti[row];
      }

      if (p == null) {
        vm.openModalError("Selezionare un solo prodotto da visualizzare.");
      } else {
        vm.product = p;
        vm.productName = null;
        if (op !== undefined && op !== null) {
          vm.productName = op.properties[0].value;
        }
        if (vm.productName === undefined || vm.productName === null) {
          vm.productName = vm.product.prodotto;
        }
        vm.$bvModal.show("modal-show");
      }
    },
    showSectionName: function(col: any) {
      const vm = this as any;

      return col.sectionName !== undefined || col.field == 'note';
    },
    showProductValue: function(col: any) {
      const vm = this as any;

      if (col.checkVisibile && !vm.isAdmin()) {
        return false;
      }

      const field = col.field;
      if (field == 'isSelected' || field == 'isToModify' || field == 'prodottoCompleto' || field == 'productCode') {
        return false;
      }

      if (vm.product[field] == undefined) {
        return false;
      }

      let value = vm.getProductValue(field);

      let isNoteFieldEmpty = false;
      if (field == 'note' && vm.isEmptyOrSpaces(value)) {
        isNoteFieldEmpty = true;
      }

      return value != vm.ND && value != "<div></div>" && value != "<div>"+vm.ND+"</div>" && !col.modalShowHidden && !isNoteFieldEmpty;
    },
    getProductValue: function(field: any) {
      const vm = this as any;

      let v = vm.product[field];

      let value = '';
      if (v.printableModalValue != undefined && v.printableModalValue != '') {
        value = v.printableModalValue;
      } else if (v.printableValue != undefined && v.printableValue != '') {
        value = v.printableValue;
      } else if (v.printableModalValue == undefined && v.printableValue == undefined) {
        value = v;
      }

      return value;
    },
    existsOneFieldOfSectionNotND: function(sectionName: string) {
      const vm = this as any;

      let isReachedSectionName = false;
      let isReachedNextSectionName = false;
      let existsOneFieldOfSectionNotND = false;
      vm.columns.forEach((col: any) => {
        if (isReachedSectionName && col.sectionName !== undefined) {
          isReachedNextSectionName = true;
        }
        if (!isReachedSectionName && col.sectionName == sectionName) {
          isReachedSectionName = true;
        }
        if (isReachedSectionName && !isReachedNextSectionName) {
          existsOneFieldOfSectionNotND = existsOneFieldOfSectionNotND || vm.showProductValue(col);
        }
      });

      return existsOneFieldOfSectionNotND;
    },
    confirmDuplicateProduct() {
      const vm = this as any;

      vm.operationToConfirm = "DUPLICATE";
      vm.openModalConfirmOperation("Si conferma di voler clonare il prodotto?");
    },    
    duplicateProduct: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      let productIdToDuplicate = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da duplicare.");
      } else {
        productIdToDuplicate = productIdsFilter[0];

        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .duplicateProduct({productId : productIdToDuplicate})
          .then(handleResponse)
          .then((result: any) => {
            vm.stopLoading();
            vm.openModalSuccess("Duplicazione prodotto avvenuta con successo (productCode = " + result.productCode + ")");
            vm.retrieveProductsList();
            return null;
          })
          .catch(() => {
            vm.openModalError("Errore generico");
          })
      }
    },
    confirmDeleteProductsList() {
      const vm = this as any;

      vm.operationToConfirm = "DELETE";
      vm.openModalConfirmOperation("Si conferma di voler eliminare il prodotto?");
    },
    deleteProductsList: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      vm.startLoading();

      const serviceCallReturnValue = await requestService.deleteProductsList({ids : productIdsFilter})
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.openModalSuccess("Eliminazione prodotti avvenuta con successo.");
          vm.retrieveProductsList();
          return null;
        })
        .catch(() => {
          vm.openModalError("Errore generico");
        })
    },
    printStringListItem(item: any) {
      return (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.value + item.valueSign
    },
    clean(s: any) {
      let str = s;
      str = str.replace(/'/g, "&apos;");
      str = str.replace(/"/g, "&quot;");
      return str;
    },
    printVersatileValues(property: any, noDashed: boolean) {
      const vm = this as any;

      let printableValue = "";
      let tooltipValue = "";
      let printableModalValue = "";

      if (property === undefined || property == null) {
        return {printableValue:printableValue,tooltipValue:tooltipValue,printableModalValue:printableModalValue};
      }

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          property.values.sort(this._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            const s = vm.splitString(item.description);
            printableValue = s[0];
            tooltipValue = s[1];
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let lis: any[] = [];
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              lis.push("<li>" + item.description + "</li>");
              return "<li>" + vm.clean(item.description) + "</li>";
            }).join("");

            if (liCounter > maxLi) {
              let spliced = lis.splice(0, maxLi);
              const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
              spliced[maxLi-1] = s;
              li = spliced.join("");
            } else {
              li = lis.join("");
            }

            printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
            if (liCounter > maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
            }
          }
        } else {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          const s = vm.splitString(vm.printStringListItem(item));
          printableValue = s[0];
          tooltipValue = s[1];
        } else if (noDashed === undefined || !noDashed) {
          const maxLi = 3;
          let liCounter = 0;
          let lis: any[] = [];
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            let valueLabel = (item.valueLabel !== undefined && !vm.isEmptyOrSpaces(item.valueLabel) ) ? item.valueLabel + " " : "";
            liCounter++;
            lis.push("<li>" + valueLabel + item.value + item.valueSign + "</li>");
            return "<li>" + vm.clean(valueLabel + item.value + item.valueSign) + "</li>";
          }).join("");

          if (liCounter > maxLi) {
            let spliced = lis.splice(0, maxLi);
            const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
            spliced[maxLi-1] = s;
            li = spliced.join("");
          } else {
            li = lis.join("");
          }

          printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
          if (liCounter > maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
          }
        } else if (noDashed) {
          let equalValues = (property.stringList.length == 2 && property.stringList[0].value == property.stringList[1].value && property.stringList[0].valueSign == property.stringList[1].valueSign && property.name != "Rendimento Gestione Separata");
          if (equalValues) {
            let str;
            if (property.stringList[0].valueSignLeft) {
              str = property.stringList[0].valueSign + " " + property.stringList[0].value;
            } else {
              const spacing = property.stringList[0].valueSign.indexOf('ann') >= 0 ? ' ' : '';
              str = property.stringList[0].value + spacing + property.stringList[0].valueSign;
            }

            const s = vm.splitString(str);
            printableValue = s[0];
            tooltipValue = s[1];
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            let lis: any[] = [];
            let splitted = false;
            // printableValue & tooltipValue
            const tooltipLi = property.stringList.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              const printableStringListItem = vm.printStringListItem(item);
              if (printableStringListItem === "") {
                return "";
              }

              liCounter++;
              const s = vm.splitString(printableStringListItem);
              if (s[0].match(new RegExp("<div>", "g")).length > 1) {
                splitted = true;
                lis.push("<li>" + s[0] + "</li>");
              } else {
                lis.push("<li>" + printableStringListItem + "</li>");
              }

              return "<li>" + vm.clean(printableStringListItem) + "</li>";
            }).join("");

            if (liCounter > maxLi) {
              let spliced = lis.splice(0, maxLi);
              const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
              spliced[maxLi-1] = s;
              li = spliced.join("");
            } else {
              li = lis.join("");
            }

            printableValue = "<ul class='nodashed'>" + li + "</ul>";
            if (liCounter > maxLi || splitted) {
              tooltipValue = "<div><ul class=\"nodashed\">" + tooltipLi + "</ul></div>";
            }
          }
        }
      } else if (property.type == propertyTypes.RANGE_FLEX) {
        let isNestedRangeValuesFlex = false;

        if (property.rangeValuesFlex.length > 0) {

          let totItems = 0;
          property.rangeValuesFlex.forEach((item: any) => {
            totItems += 1; // contributo elemento lista property.rangeValuesFlex
            if (item.rangeValuesFlex !== undefined && item.rangeValuesFlex !== null) {
              if (item.rangeValuesFlex.length > 0) {
                totItems += 1 + item.rangeValuesFlex.length; // 1 è la label fissa che fa riga a sè stante
              }
            }
          });

          const maxLi = 3;
          let liCounter = 0;
          let liItemsPV = "";
          let liItemsTV = "";
          property.rangeValuesFlex.forEach((item: any) => {
            liCounter++;

            const label = (item.label !== undefined && !vm.isEmptyOrSpaces(item.label)) ? item.label + " " : "";

            const spacingFrom = item.fromSignLeft || item.fromSign.indexOf('ann') >= 0 ? ' ' : '';
            const from = item.fromSignLeft ? item.fromSign + spacingFrom + item.from : item.from + spacingFrom + item.fromSign;
            
            const spacingTo = item.toSignLeft || item.toSign.indexOf('ann') >= 0 ? ' ' : '';
            const to = item.toSignLeft ? item.toSign + spacingTo + item.to : item.to + spacingTo + item.toSign;

            let value = undefined;
            if (item.showValue) {
              const spacingValue = item.valueSignLeft || item.valueSign.indexOf('ann') >= 0 ? ' ' : '';
              value = item.valueSignLeft ? item.valueSign + spacingValue + item.value : item.value + spacingValue + item.valueSign;
            }
            // liItem
            let liItem =  label + from + " " + item.fromToOperator + " " + to;
            if (value !== undefined) {
              liItem +=  " " + item.toValueOperator + " " + value;
            }
            // printableValue
            let s = liItem;
            if (liCounter == maxLi && property.rangeValuesFlex.length > maxLi) {
              s += " ...";
            }
            if (liCounter <= maxLi || totItems == maxLi) {
              liItemsPV += "<li>" + s + "</li>";
            }
            // tooltipValue
            liItemsTV += "<li>" + vm.clean(liItem) + "</li>";

            // L2
            let liItemsPVL2 = "";
            let liItemsTVL2 = "";
            const noDashSpace = "&nbsp;&nbsp;&nbsp;&nbsp;";
            if (item.rangeValuesFlex !== undefined && item.rangeValuesFlex !== null) {
              if (item.rangeValuesFlex.length > 0) {
                isNestedRangeValuesFlex = true;

                item.rangeValuesFlex.forEach(function(itemL2: any) {
                  liCounter++;

                  const isLabelL2 = (itemL2.label !== undefined && !vm.isEmptyOrSpaces(itemL2.label));
                  const labelL2 = isLabelL2 ? "-&nbsp;&nbsp;" + itemL2.label + " " : "";

                  const spacingFromL2 = itemL2.fromSignLeft || itemL2.fromSign.indexOf('ann') >= 0 ? ' ' : '';
                  const fromL2 = itemL2.fromSignLeft ? itemL2.fromSign + spacingFromL2 + itemL2.from : itemL2.from + spacingFromL2 + itemL2.fromSign;

                  const spacingToL2 = itemL2.toSignLeft || itemL2.toSign.indexOf('ann') >= 0 ? ' ' : '';
                  const toL2 = itemL2.toSignLeft ? itemL2.toSign + spacingToL2 + itemL2.to : itemL2.to + spacingToL2 + itemL2.toSign;

                  let valueL2 = undefined;
                  if (itemL2.showValue) {
                    const spacingValueL2 = itemL2.valueSignLeft || itemL2.valueSign.indexOf('ann') >= 0 ? ' ' : '';
                    valueL2 = itemL2.valueSignLeft ? itemL2.valueSign + spacingValueL2 + itemL2.value : itemL2.value + spacingValueL2 + itemL2.valueSign;
                  }
                  let liItemL2 = fromL2 + " " + itemL2.fromToOperator + " " + toL2;
                  if (valueL2 !== undefined) {
                    liItemL2 +=  " " + itemL2.toValueOperator + " " + valueL2;
                  }
                  // printableValue L2
                  if (liCounter < maxLi || totItems == maxLi) {
                    if (isLabelL2 && liCounter < maxLi) {
                      liItemsPVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                      liCounter++;
                    }
                  }
                  let s = noDashSpace + liItemL2;
                  if (liCounter == maxLi) {
                    s += " ...";
                  }
                  if (liCounter <= maxLi || totItems == maxLi) {
                    liItemsPVL2 += "<li>" + s + "</li>";
                  }
                  // tooltipValue L2
                  liItemsTVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                  liItemsTVL2 += "<li>" + noDashSpace + liItemL2 + "</li>";
                });

                liItemsPV += "<div><ul class='nodashed'>" + liItemsPVL2 + "</ul></div>";

                liItemsTV += "<div><ul class=\"nodashed\">" + liItemsTVL2 + "</ul></div>";
              }
            }
          });

          let dashClass = "nodashed";
          if (isNestedRangeValuesFlex) {
            dashClass = "dashed";
          }

          printableValue = "<div><ul class='" + dashClass + "'>" + liItemsPV + "</ul></div>";
          if (liCounter > maxLi) {
            tooltipValue = "<div><ul class=\"" + dashClass + "\">" + liItemsTV + "</ul></div>";
          }
        } else {
          if (property.valueSign !== undefined && property.valueSign !== null) {
            if (property.valueSign.length > 0) {
              printableValue = property.value + property.valueSign;
            }
          }
          if (printableValue === undefined || vm.isEmptyOrSpaces(printableValue)) {
            printableValue = property.value;
          }
          
          const s = vm.splitString(printableValue);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (property.type == propertyTypes.FRAZIONAMENTO) {
        if (property.value === vm.ND) {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        } else {
          let values: any[] = [];
          if (property.frazionamento.mensile !== vm.ND) {
            values.push("Mensile: " + property.frazionamento.mensile + property.frazionamento.mensileSign);
          }
          if (property.frazionamento.bimestrale !== vm.ND) {
            values.push("Bimestrale: " + property.frazionamento.bimestrale + property.frazionamento.bimestraleSign);
          }
          if (property.frazionamento.trimestrale !== vm.ND) {
            values.push("Trimestrale: " + property.frazionamento.trimestrale + property.frazionamento.trimestraleSign);
          }
          if (property.frazionamento.quadrimestrale !== vm.ND) {
            values.push("Quadrimestrale: " + property.frazionamento.quadrimestrale + property.frazionamento.quadrimestraleSign);
          }
          if (property.frazionamento.semestrale !== vm.ND) {
            values.push("Semestrale: " + property.frazionamento.semestrale + property.frazionamento.semestraleSign);
          }
          if (values.length == 1) {
            printableValue = values[0];
          } else if (values.length > 1) {
            const maxLi = 3;
            let liCounter = 0;
            let lis: any[] = [];
            let li = "";
            const tooltipLi = values.map(function(s: any) {
              liCounter++;
              lis.push("<li>" + s + "</li>");
              return "<li>" + vm.clean(s) + "</li>";
            }).join("");

            if (liCounter > maxLi) {
              let spliced = lis.splice(0, maxLi);
              const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
              spliced[maxLi-1] = s;
              li = spliced.join("");
            } else {
              li = lis.join("");
            }

            printableValue = "<ul class='dashed'>" + li + "</ul>"
            if (liCounter > maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
            }
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (property.value !== undefined && property.value !== null) {
        const s = vm.splitString(vm.printWithSign(property));
        printableValue = s[0];
        tooltipValue = s[1];
      }

      if (tooltipValue !== undefined && !this.isEmptyOrSpaces(tooltipValue)) {
        printableModalValue = tooltipValue;
        tooltipValue = vm.escapeHtml(tooltipValue);
      }

      return {printableValue:printableValue,tooltipValue:tooltipValue,printableModalValue:printableModalValue};
    },
    printNewLine(s: any) {
      if (s !== undefined) {
        return s
          .replace(/\n/g, "<br/>")
          .replace(/\'/g, "&rsquo;")
        ;
      }

      return s;
    },
    splitString(str: any) {
      const vm = this as any;

      const maxRows = 3;
      const maxCharsPerRow = 40;
      let printableValue = "";
      let tooltipValue = "";

      if (str === undefined) {
        return [printableValue, tooltipValue];
      }

      let brArray = str.split("\n");
      let brDiv = [] as any;
      brArray.forEach((item: any) => {
        let itemWords = item.split(" ");
        let concatWords = "";
        for (let i = 0; i < itemWords.length; i++) {
          let word = itemWords[i];
          if (i == 0) {
            concatWords = word;
          } else {
            if ((concatWords + word).length < maxCharsPerRow) {
              concatWords = concatWords + " " + word;
            } else {
              brDiv.push(concatWords);
              concatWords = word;
            }
          }

          // gestione last element
          if (i+1 == itemWords.length) {
            brDiv.push(concatWords);	
          }
        }
      });

      let flagDots = false;
      if (brDiv.length > maxRows) {
        flagDots = true;
        for (let i = 0; i < maxRows; i++) {
          let s = brDiv[i];
          if (i == maxRows - 1) {
            s += " ...";
          }
          printableValue += "<div>" + s + "</div>";
        }
      } else {
        for (let i = 0; i < brDiv.length; i++) {
          printableValue += "<div>" + brDiv[i] + "</div>";
        }
      }

      if (flagDots) {
        tooltipValue = vm.printNewLine(str);
      }

      return [printableValue, tooltipValue];
    },
    printWithSign(property: any) {
      const vm = this as any;

      const value = vm.stringify(property.value);
      if (value != '' && value != vm.ND) {
        const sign = vm.stringify(property.valueSign !== undefined ? property.valueSign : "");

        const spacing = property.valueSignLeft || sign.indexOf('ann') >= 0 ? ' ' : '';

        if (property.valueSignLeft) {
          return sign + spacing + value;
        }
        return value + spacing + sign;
      }

      return value;
    },
    _compare: function(a: any, b: any) {
      const aCode = a.code;
      const bCode = b.code;
      if (aCode === undefined || bCode === undefined) {
        if (bCode !== undefined) {
          return -1;
        }
        if (aCode !== undefined) {
          return 1;
        }
        return 0;
      }

      let aSplit = aCode.split(".");
      let bSplit = bCode.split(".");
      if (aSplit.length > 1 && bSplit.length > 1) {
        let aPre = parseInt(aSplit[0]);
        let aPost = parseInt(aSplit[1]);
  
        let bPre = parseInt(bSplit[0]);
        let bPost = parseInt(bSplit[1]);

        if (aPre == bPre) {
          if (aPost < bPost) {
            return -1;
          }
          if (aPost > bPost) {
            return 1;
          }
          return 0;
        } else if (aPre < bPre) {
          return -1;
        } else {
          return 1;
        }
      }

      if (aCode < bCode) {
        return -1;
      }
      if (aCode > bCode) {
        return 1;
      }
      return 0;
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    countFrazionamento(prop: any) {
      const vm = this as any;
      let count = 0;

      if (prop !== undefined && prop.frazionamento !== undefined) {
        const f = prop.frazionamento;
        if (f.mensile !== vm.ND) count++;
        if (f.bimestrale !== vm.ND) count++;
        if (f.trimestrale !== vm.ND) count++;
        if (f.quadrimestrale !== vm.ND) count++;
        if (f.semestrale !== vm.ND) count++;
      }

      return count;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    openModalSuccess(msg: string) {
      const vm = this as any;
      vm.msgSuccess = msg;
      vm.$bvModal.show("modal-success");
    },
    closeModalSuccess() {
      const vm = this as any;
      vm.$bvModal.hide("modal-success");
    },
    onClickReturnSuccess() {
      const vm = this as any;
      vm.closeModalSuccess();
    },
    openModalError(msg: string) {
      const vm = this as any;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    openModalConfirmOperation(msg: string) {
      const vm = this as any;
      vm.msgConfirmOperation = msg;
      vm.$bvModal.show("modal-confirm-operation");
    },
    closeModalConfirmOperation() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-operation");
    },
    onClickReturnConfirmOperation() {
      const vm = this as any;
      if (vm.operationToConfirm == "DELETE") {
        vm.deleteProductsList();
      } else if (vm.operationToConfirm == "DUPLICATE") {
        vm.duplicateProduct();
      }
      vm.operationToConfirm == "";
      vm.closeModalConfirmOperation();
    },
    closeModalShow() {
      const vm = this as any;
      vm.$bvModal.hide("modal-show");
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    isAdmin: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('admin-view') >= 0;
      }
      return false;
    },
    isAdvanced: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('advanced') >= 0;
      }
      return false;
    },
    noDashboard: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('no-dashboard') >= 0;
      }
      return false;
    },
    isModifyProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('modifica-prodotto') >= 0;
      }
      return false;
    },
    isDuplicateProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('duplica-prodotto') >= 0;
      }
      return false;
    },
    isDeleteProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('elimina-prodotto') >= 0;
      }
      return false;
    },
    prepareJqueryEvents: function() {
      const vm = this as any;

      vm.destroyJqueryEvents();

      jquery("div.dataTables_scrollFoot").hide();

      (jquery('[data-toggle="tooltip"]') as any).tooltip();

      vm.scrollTables = jquery("div.dataTables_scrollHead, div.dataTables_scrollBody");

      jquery(".selectProd").on("click", vm.selectProdClick);
      jquery(".modifyProd").on("click", vm.modifyProdClick);
      jquery(".showProd").on("click", vm.showProdClick);

      jquery(".multiheader[colspan='1']").addClass('force-width');
      jquery(".multiheader[colspan='1'] > div").addClass('force-width');

      if (vm.selectAll) {
        // nel caso in cui cambi "pagina" della tabella con selectAll = true
        jquery('.selectProd').prop('checked', vm.selectAll);
      }
    },
    destroyJqueryEvents: function() {
      const vm = this as any;

      (jquery('[data-toggle="tooltip"]') as any).tooltip('dispose');

      jquery(".selectProd").off("click", vm.selectProdClick);
      jquery(".modifyProd").off("click", vm.modifyProdClick);
      jquery(".showProd").off("click", vm.showProdClick);
    },
    scrollTo: function(id: string) {
      const vm = this as any;

      const elementToScrollTo = jquery('#' + id);
      if (elementToScrollTo != undefined && elementToScrollTo.offset() != undefined) {
        const offset = elementToScrollTo.offset();

        const body = jquery("div.dataTables_scrollBody");
        var bodyLeft = body.scrollLeft();
        if (bodyLeft == undefined) {
          bodyLeft = 0;
        }

        if (offset != undefined) {
          const offsetLeft = offset.left - 50;
          vm.scrollTables.scrollLeft(bodyLeft + offsetLeft, 0);
        }
      }
    },
    selectProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isSelectedProd_'.length);
        vm.setIsSelected(id);
      }
    },
    modifyProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isToModifyProd_'.length);
        (jquery('#'+event.currentTarget.id) as any).tooltip('dispose');
        vm.modifyProduct(id);
      }
    },
    showProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isToShowProd_'.length);
        vm.showProduct(id);
      }
    },
    escapeHtml(value: string) {
      return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    handlePageInput(val: number) {
      const vm = this as any;
      vm.page = val;
      vm.listaProdottiCensitiCurrent = vm.listaProdottiCensitiPaginati[val-1];
      
      const sizeLastPage = (vm.page - 1)*vm.itemsPerPage;
      vm.pageStart = sizeLastPage + 1;
      vm.pageEnd = sizeLastPage + vm.listaProdottiCensitiCurrent.length;
    },
  },
  mounted() {
    const vm = this as any;

    if (!vm.loggedUser) {
      vm.homeProdotti();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('cpi-ppi') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.homeProdotti();
      }
    }

    vm.columns.forEach(function (c: any) {
      if (!c.orderable) {
        c.orderable = false;
      }
      if (c.checkVisible) {
        c.visible = vm.isAdmin();
      }
    });
  },
  beforeDestroy() {
    const vm = this as any;

    vm.destroyJqueryEvents();
  },
  created() {
    if (!this.isAdmin()) {
      //this.options.fixedColumns.leftColumns = 5; // prodotto (vanno contate anche quelle non visibili per ruolo)
      this.options.fixedColumns.leftColumns = 0;
    } else {
      this.options.fixedColumns.leftColumns = 0;
    }

    this.inizializzaFiltroRicerca();

    this.getPropertyValues()
      .then(result => {
        this.resetFilterOptions();
      });

    this.retrieveProductsList();
  }
});
